import React, { useEffect, useMemo, useState } from 'react'
import GoBack from "../subsidiary/GoBack/GoBack";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import styles from './NewTicket.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { createTicket, fetchTicketTheme, } from '../Tickets/ticketSlice'
import { useNavigate } from 'react-router-dom';

const NewTicket = () => {
    const dispatch = useDispatch()
    const token = useSelector(state => state.loginSlice.token)
    const themesRaw = useSelector(state => state.ticketSlice.themes)
    const themes = useMemo(() => (Array.isArray(themesRaw) ? themesRaw : []), [themesRaw])
    const [name, setName] = useState('')
    const [message, setMessage] = useState('')
    const navigation = useNavigate()
    const themeChange = (e) => {
        setName(e.target.value)
    }
    const messageChange = (e) => {
        setMessage(e.target.value)
    }
    const handleCreateTicket = () => {
        dispatch(createTicket({ name, message, token })).then((params) => {
            if (!params.error) {
                navigation('/tickets')
                window.showAlert({title: 'Успешно отправлено', type: 'success'})
            }
            else {
                window.showAlert({title: 'Что то пошло не так', type: 'error'})
            }
        })
    }
    useEffect(() => {
        dispatch(fetchTicketTheme({ token }))
    }, [dispatch])
    return (
        <>
            <div className="content-wrapper">
                <section className={"main " + styles.wrapper} >
                    <GoBack text='назад' />
                    <div className="content-wrapper">
                        <div className="page-title-container">
                            <h1 className="page-title ">
                                Создать тикет
                            </h1>
                        </div>
                        <div>
                            <FormControl style={{ width: '100%' }}>
                                <InputLabel id="demo-multiple-name-label">Тема проблемы</InputLabel>
                                <Select
                                    style={{ marginBottom: '22px' }}
                                    labelId="demo-multiple-name-label"
                                    id="demo-multiple-name"
                                    input={<OutlinedInput label="Тема проблемы" />}
                                    value={name}
                                    onChange={themeChange}
                                >
                                    {themes.map((theme) => {
                                        const label = typeof theme === 'object' && theme != null
                                            ? (theme.name ?? theme.title ?? '')
                                            : String(theme ?? '')
                                        const value = typeof theme === 'object' && theme != null
                                            ? (theme.name ?? theme.id ?? label)
                                            : theme
                                        return (
                                            <MenuItem key={String(value)} value={value}>
                                                {label || '—'}
                                            </MenuItem>
                                        )
                                    })}

                                    {/*<MenuItem value='second'>*/}
                                    {/*    test*/}
                                    {/*</MenuItem>*/}
                                    {/*<MenuItem value='third'>*/}
                                    {/*    Еще текст*/}
                                    {/*</MenuItem>*/}
                                </Select>
                                <textarea
                                    className={styles.messageField}
                                    onChange={messageChange}
                                    placeholder="Сообщение"
                                />
                                <Button onClick={handleCreateTicket} className={styles.sendBtn} variant="contained">Отправить</Button>
                            </FormControl>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
export default NewTicket
